import {combineReducers} from 'redux';
import alert from './alertReducer';
//增加引入
import citySelect from './citySelectReducer';
import roomList from './roomListReducer';
import collection from './collectionReducer';
import setting from './settingReducer';
import home from './homeReducer';

export default combineReducers({
    //抛出引入
    home,
    collection,
    setting,
    alert,
    citySelect,
    roomList,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js